<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="text-center">
                    <p class="mb-0 text-muted">&copy;
                        <script>document.write(new Date().getFullYear())</script> Shri Bhagiyalakshimi Travels.
                        Developed & Designed by <a href="https://www.genuineitsolution.in" target="_blank" class="text-decoration-underline text-reset">Genuine IT Solution</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</footer>